(() => {
  const initialized = new WeakSet();
  function init() {
    document.querySelectorAll('[data-zorsay-navigation]').forEach(header => {
      if (initialized.has(header)) return;
      initialized.add(header);
      const toggle = header.querySelector('.menu-button');
      const menu = header.querySelector('#mobile-menu');
      if (!toggle || !menu) return;
      const close = (restoreFocus = false) => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        if (restoreFocus) toggle.focus();
      };
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        menu.hidden = !open;
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) {
          event.preventDefault();
          close(true);
        }
      });
      header.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!header.contains(document.activeElement)) close();
        });
      });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) close();
      });
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) close();
        // Saved controls open a modal; closing this disclosure avoids stacked overlays.
        if (event.target.closest('[data-open-favorites],[data-open-compare]')) close();
      });
      window.addEventListener('pageshow', () => close());
    });
  }
  document.addEventListener('shopify:section:load', init);
  init();
})();
